'use client';

import React from 'react';
import type { SmartCursorContextProps } from './types';
import { INITIAL_SMART_CURSOR_CONTEXT } from './consts';

const SmartCursorContext = React.createContext<SmartCursorContextProps>(
  INITIAL_SMART_CURSOR_CONTEXT,
);

export default SmartCursorContext;
